import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../Context/ContextFunctions";
import SuryaLogoMain from "../../assets/images/SuryaLogoMain.png";
import { VerifyLoginCredential } from "../../services/Login/LoginApi";
import { ERROR_MESSAGES } from "../../components/common/GlobalMassssage";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
const Login = () => {
  const { setLoginItem } = useContext(AuthContext); // Access setLoginItem from context
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const [requireErrorMessage, setRequireErrorMessage] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState();
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { setLoader } = useContext(LoaderContext); //Get Loader

  const [loading, setLoading] = useState(false); // Define loading state
  const [LoginObj, setLoginObj] = useState({
    mobileNo: "",
    password: "",
    token: null,
    macAddress: null
  });

  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const fingerprint = result.visitorId;
      setLoginObj(prev => ({
        ...prev,
        macAddress: fingerprint,
      }));
      console.log('Unique Fingerprint:', fingerprint);
    };
    loadFingerprint();
  }, []);

  const LoginBtnClicked = () => {
    //
    let isError = false;
    setErrorMessage("");
    if (
      LoginObj.mobileNo === null ||
      LoginObj.mobileNo === undefined ||
      LoginObj.mobileNo === "" ||
      LoginObj.password === null ||
      LoginObj.password === undefined ||
      LoginObj.password === ""
    ) {
      setError(true);
      isError = true;
    } else if (
      LoginObj.mobileNo !== null &&
      LoginObj.mobileNo !== undefined &&
      LoginObj.mobileNo !== "" &&
      LoginObj.mobileNo.toString().length !== 10
    ) {
      setErrorMessage("Enter 10 digit mobile No.");

      isError = true;
    } else if (
      LoginObj.password !== null &&
      LoginObj.password !== undefined &&
      LoginObj.password !== "" &&
      LoginObj.password.toString().length < 8
    ) {
      setErrorMessage("Enter 8 digit password");
      setError(true);
      isError = true;
    }

    const ApiRequest_ParamsObj = {
      mobileNo: LoginObj.mobileNo,
      password: LoginObj.password,
      loginFrom: "Admin Panel",
      macAddress: LoginObj?.macAddress
    };
    // LoginData(ApiRequest_ParamsObj);
    const userID = 1; // Replace with actual user ID from API response

    if (!isError) {
      LoginData(ApiRequest_ParamsObj);
    }
  };

  const LoginData = async (ApiRequest_ParamsObj) => {
    // setLoading(true); // Start loading
    setLoader(true);
    try {
      const response = await VerifyLoginCredential(ApiRequest_ParamsObj);
      if (response?.data?.statusCode === 200) {
        setLoader(false);

        const modelData = response?.data?.responseData?.data;
        // Update the context with login data and store it in localStorage
        setLoginItem({
          mobileNo: modelData.mobileNo,
          password: modelData.password,
          token: modelData.token,
          employeeName: modelData.employeeName,
          userKeyID: modelData.userKeyID,
          roleTypeID: modelData.roleTypeID,
          emailID: modelData.emailID,
          permissionModule: modelData.userAccessList,
          userTypeID: modelData?.userTypeID,
          canApprovedQuotation: modelData?.canApprovedQuotation,
          isAdminUser: (modelData.roleTypeID === 1 || modelData?.userTypeID === 1) ? true : false,
        });
        navigate("/");
        const token = modelData.token;
      } else {
        const errorMessage =
          response?.response?.data?.errorMessage || "An error occurred.";
        setLoader(false);

        setErrorMessage(errorMessage);
      }
    } catch (error) {
      setLoader(false);

      console.error("Login failed:", error);
      setErrorMessage(`${error}`);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  return (
    <section
      id="Login"
      className="text-gray-600 body-font sticky top-0"
      style={{ position: "sticky", width: "71%" }}
    >
      <div className="container flex flex-col md:flex-row items-center px-5">
        {/* Left Side: Logo */}
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col items-center md:items-start text-center md:text-left mb-8 md:mb-0 hidden md:block">
          <img alt="Logo" src={SuryaLogoMain} width={250} />
        </div>

        {/* Right Side: Login Box */}
        <div className="lg:max-w-lg w-full md:w-2/3 lg:w-1/2 mx-auto border border-gray-300 shadow-lg p-6 md:p-8 rounded-lg">
          <div className="flex justify-center mb-6">
            <img
              alt="Logo inside the box"
              src={SuryaLogoMain}
              className="w-1/3"
            />
          </div>
          <div className="text-center font-semibold text-xl md:text-2xl mb-6">
            Log In to Admin Panel
          </div>
          {ErrorMessage && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-sm text-center"
              role="alert"
            >
              {ErrorMessage}
            </div>
          )}

          {/* Mobile Number Input */}
          <div className="mb-4">
            <label className="block font-medium text-gray-700 mb-2">
              Mobile Number <span className="text-red-500">*</span>
            </label>
            <input
              className="p-3 pr-10 border rounded bg-gray-100 focus:outline-none focus:ring focus:ring-blue-200 w-full"
              placeholder="Enter Mobile No."
              value={LoginObj.mobileNo}
              maxLength={10}
              type="text"
              autoComplete="off"
              onChange={(e) => {
                const inputValue = e.target.value.replace(/[^0-9]/g, "");
                setLoginObj({
                  ...LoginObj,
                  mobileNo: inputValue.replace(/^[0-5]/, ""),
                });
              }}
              required
            />
            {error && !LoginObj.mobileNo ? (
              <span className="text-red-500 text-sm mt-2">
                {ERROR_MESSAGES}
              </span>
            ) : error && LoginObj.mobileNo?.length !== 10 ? (
              <span className="text-red-500 text-sm mt-2">
                Enter 10 digit Mobile No
              </span>
            ) : null}
          </div>

          {/* Password Input */}
          <div className="mb-6 relative">
            <label className="block font-medium text-gray-700 mb-2">
              Password <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                className="p-3 pr-10 border rounded bg-gray-100 focus:outline-none focus:ring focus:ring-blue-200 w-full"
                placeholder="Enter Password"
                maxLength={20}
                required
                type={showPassword ? "text" : "password"}
                value={LoginObj.password}
                onChange={(e) => {
                  const passwordWithoutSpaces = e.target.value.replace(
                    /\s+/g,
                    ""
                  );
                  setLoginObj({
                    ...LoginObj,
                    password: passwordWithoutSpaces,
                  });
                }}
              />
              <button
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                type="button"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {error && !LoginObj.password ? (
              <span className="text-red-500 text-sm mt-2">
                {ERROR_MESSAGES}
              </span>
            ) : error && LoginObj.password?.length < 8 ? (
              <span className="text-red-500 text-sm mt-2">
                Enter 8 digit password
              </span>
            ) : null}
          </div>

          {/* Login Button */}
          <div className="text-center">
            <button
              className="w-full bg-blue-500 text-white py-3 rounded font-bold hover:bg-blue-600 transition duration-200"
              type="button"
              onClick={LoginBtnClicked}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
